import React, { FC } from "react";
import ContentLoader from "react-content-loader";

import { i18n } from "@utils/i18n";

export type SkeletonTabsProps = {
  tabsCount?: number;
};

const SkeletonTabs: FC<SkeletonTabsProps> = ({ tabsCount = 3 }) => {
  const isRTL = i18n.dir() === "rtl";

  return (
    <>
      {/* Tab headers */}
      <div
        style={{
          display: "flex",
          flexDirection: isRTL ? "row-reverse" : "row",
          gap: "12px",
          marginBottom: "16px",
        }}
      >
        {Array.from({ length: tabsCount }, (_, index) => (
          <ContentLoader
            key={`tab-header-${index}`}
            height={40}
            width={120}
            speed={2}
            style={{ borderRadius: "5px" }}
          >
            <rect x="0" y="0" rx="5" ry="5" width="120" height="40" />
          </ContentLoader>
        ))}
      </div>

      {/* Tab content */}
      <ContentLoader
        height={200}
        width="100%"
        speed={2}
        style={{
          width: "100%",
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px 0px",
          borderRadius: "5px",
          padding: "24px",
          display: "flex",
          gap: "16px",
        }}
        rtl={isRTL}
      >
        <rect x="0" y="0" rx="5" ry="5" width="80%" height="30" />
        <rect x="0" y="64" rx="5" ry="5" width="90%" height="18" />
        <rect x="0" y="94" rx="5" ry="5" width="85%" height="18" />
        <rect x="0" y="124" rx="5" ry="5" width="92%" height="18" />
      </ContentLoader>
    </>
  );
};

export default SkeletonTabs;
